import React from "react";
import { CreateInventoryTransferModal } from "../inventory/transfer/Modals/Create/CreateInventoryTransferModal";
import InventoryTransferDetailModal from "../inventory/transfer/Modals/TransferDetail/InventoryTransferDetailModal";
import InventoryTransferEditModal from "../inventory/transfer/Modals/TransferEdit/InventoryTransferEditModal";
import InventoryTransferApproveModal from "../inventory/transfer/Modals/Approve/InventoryTransferApproveModal";
import InventoryTransferConfirmModal from "../inventory/transfer/Modals/Confirm/InventoryTransferConfirmModal";
import InventoryTransferCancelModal from "../inventory/transfer/Modals/Cancel/InventoryTransferCancelModal";
import InventoryTransferRejectModal from "../inventory/transfer/Modals/Reject/InventoryTransferRejectModal";
import InventoryTransferReverseModal from "../inventory/transfer/Modals/Reverse/InventoryTransferReverseModal";

// =========================
// INVENTARIO — TRASLADOS
// =========================

// =========================
// VENTAS — MODALES (a futuro)
// =========================
// import PendingSaleModal from "../Sale/history/PendingSaleModal";


// =========================
// COMPONENTE GLOBAL
// =========================
const GlobalModalsProvider: React.FC = () => {
  return (
    <>
      {/* ===================================================== */}
      {/* =============== MODALES GLOBAL INVENTARIO =========== */}
      {/* ===================================================== */}

      <CreateInventoryTransferModal />
      <InventoryTransferDetailModal />
      <InventoryTransferEditModal />
      <InventoryTransferApproveModal />
      <InventoryTransferConfirmModal />
      <InventoryTransferCancelModal />
      <InventoryTransferRejectModal />
      <InventoryTransferReverseModal />

      {/* ===================================================== */}
      {/* =============== MODALES GLOBAL VENTAS =============== */}
      {/* ===================================================== */}

      {/* <PendingSaleModal /> */}

      {/* ===================================================== */}
      {/* =============== MODALES GLOBAL COMPRAS ============== */}
      {/* ===================================================== */}

      {/* Aquí agregas en el futuro */}
    </>
  );
};

export default GlobalModalsProvider;
